export default __webpack_public_path__ + "static/media/330_store04-nl-mobile.ccd54c37.png";